export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "http://localhost:3000",
    backendUrl: "http://localhost:3100",
    appBackendUrl: "http://localhost:4040",
    jsReportUrl: "http://localhost:5488",
    s3Url: "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://qa-app.summerbayresort.com.my";
    exportResult.backendUrl = "https://qa-api.summerbayresort.com.my/admin";
    exportResult.appBackendUrl = "https://qa-api.summerbayresort.com.my/app";
    exportResult.jsReportUrl = "https://qa-report.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.appBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-test.s3.ap-southeast-1.amazonaws.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.summerbayresort.com.my";
    exportResult.backendUrl = "https://api.summerbayresort.com.my/admin";
    exportResult.appBackendUrl = "https://api.summerbayresort.com.my/app";
    exportResult.jsReportUrl = "https://report.summerbayresort.com.my";
    exportResult.s3Url = "https://sbay-s3b-prod.s3.ap-southeast-1.amazonaws.com";
  }
  return exportResult;
};
